/* eslint-disable max-len */
/**
 * French translations.
 */
export default {
  ACTION: {
    CAMPAIGNS: 'Campagnes',
    CERTIFICATES: 'Certificats',
    CHALLENGES: 'Défis',
    CHAT: 'Chat',
    CLOSE: 'Fermer',
    CLUB: 'Club',
    COMMISSIONED_PRODUCTS: 'Produits commandés',
    COMMUNICATIONS: 'Communications',
    CONFIRM: 'Confirmer',
    COUNTERPART: 'Contreparties',
    DASHBOARD: 'Tableau de bord',
    DESIGN_REQUESTS: 'Demandes de conception',
    DETAILS: 'Détails',
    EXTERNAL_APPLICATIONS: 'Applications externes',
    FOLLOWER_MESSAGES: 'Messages de followers',
    GENERICS: 'Génériques',
    LINKS: 'Liens',
    LIVE: 'Directs',
    LOGOUT: 'Déconnexion',
    MEMBERS: 'Membres',
    MENTIONS: 'Mentionne',
    OFFERS: 'Offres',
    ON_DEMAND_CAMPAIGNS: 'Campagnes sur demande',
    OPPORTUNITIES: 'Opportunités',
    ORDERS: 'Commandes payées',
    PARTNERS: 'Partenaires',
    PERSONAL_AREA: 'Espace personnel',
    PRODUCTS_OFFERED: 'Produits offerts',
    PROFILE: 'Profil',
    PROZIS_COMMUNITY: 'Communauté Prozis',
    QUESTIONS: 'Questions',
    REMUNERATIONS: 'Rémunérations',
    SELECT_LANGUAGE: 'Sélectionner la langue',
    SELECT_PARTNER: 'Sélectionner un autre partenaire',
    SERVICES: 'Services',
    SOCIAL_NETWORK: 'Réseau social Prozis',
    STATISTICS: 'Statistiques',
    VIDEO_TUTORIALS: 'Tutoriels vidéo'
  },
  ERROR: {
    ERROR: 'Erreur',
    FETCH_DATA: 'Récupérer des données'
  },
  HEADER: {},
  LABEL: {
    CAMPAIGNS: 'Campagnes',
    CHALLENGES: 'Défis',
    CHAT: 'Chat',
    COMMUNICATIONS: 'Communications',
    COUNTERPARTS: 'Contreparties',
    DASHBOARD: 'Tableau de bord',
    DESIGN_REQUESTS: 'Demandes de conception',
    DETAILS: 'Détails',
    EXTERNAL_APPLICATIONS: 'Applications externes',
    FILTER: 'Filtrer',
    FILTERED: 'Filtré',
    FOLLOWER_MESSAGES: 'Messages de followers',
    GENERICS: 'Génériques',
    HOME: 'Accueil',
    LINKS: 'Liens',
    LOGOUT: 'Déconnexion',
    MEMBERS: 'Membres',
    MENTIONS: 'Mentions Instagram',
    NOT_FOUND: '404, Es-tu perdu ?',
    OFFERS: 'Offres',
    ORDERS: 'Commandes',
    PARTNERSHIP_NOT_FOUND: 'Aucun partenariat trouvé.',
    PENDING_COUNTERPART: 'Contreparties en attente de la période précédente',
    PENDING_COUNTERPART_CURRENT: 'Contreparties en attente du mois actuel',
    PENDING_REMUNERATION: 'Rémunérations en attente de la période précédente',
    PENDING_REMUNERATION_CURRENT: 'Rémunérations en attente du mois actuel',
    PERSONAL_AREA: 'Espace personnel',
    PRODUCTS: 'Produits',
    REMUNERATIONS: 'Rémunérations',
    SEARCH_PARTNERSHIP: 'Rechercher un partenariat',
    SELECT_LANGUAGE: 'Sélectionner la langue',
    SELECT_PARTNERSHIP: 'Sélectionner un partenariat',
    UNAUTHROZIED: '403, Accès non autorisé !'
  },
  SENTENCE: {},
  SUCCESS: {},
  TOOLTIP: {}
};
